import { useState } from 'react'
import { InputField } from 'components'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import LoaderButton from 'components/molecules/loader-button'
import customerCheckoutCartFormSchema from 'domains/customer-checkout/organisms/cart-form/customer-checkout-cart-form-schema'
import ProductSelectSearchField from 'domains/product/molecules/select-search-field'
import ProductApiV2 from 'api/v2/admins/products-api-v2'

const propTypes = {
  onSubmit : PropTypes.func.isRequired,
  customer : PropTypes.object.isRequired
}

/**
 * Form to add cart items
 * @param {func} onSubmit Handler for submitting the form
 * @param {object} customer object of customer
 * @param {object} cart object of customer cart
 */
const CustomerCheckoutCartForm = ({
  onSubmit,
  customer
}) => {

  const [ productDimensions, setProductDimensions ] = useState([])

  const DimensionList = () => {
    const optionsComponent = productDimensions.map((dimension) => (
      <option
        key={ `${dimension.id}-option` }
        value={ dimension.id }
      >
        { (dimension.size) || ('All Size') }
      </option>
    ))
    return (
      <>
        <option key=''>Choose one</option>
        { optionsComponent }
      </>
    )
  }

  const handleSelectProductSearch = (product) => {
    ProductApiV2.show(product.id)
      .then((response) => setProductDimensions(response.data.product.dimensions))
      .catch(() => alert('Unable to fetch Product Dimensions'))
  }

  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{
        customer             : customer,
        product              : '',
        product_dimension_id : '',
        quantity             : 1
      }}
      validationSchema={ customerCheckoutCartFormSchema }
      onSubmit={ onSubmit }
    >
      {
        (formikBag) => (
          <Form>
            <ProductSelectSearchField
              name='product'
              label='Product'
              required={ true }
              onSelect={ handleSelectProductSearch }
            />
            <InputField
              type='select'
              name='product_dimension_id'
              label='Dimension (Size)'
              required={ true }
            >
              <DimensionList/>
            </InputField>
            <InputField
              type='number'
              name='quantity'
              label='Quantity'
              placeholder='1'
              required={ true }
            />
            <LoaderButton
              color='primary'
              type='submit'
              isLoading={ formikBag.isSubmitting }
              text='Add'
            />
          </Form>
        )
      }
    </Formik>
  )
}

CustomerCheckoutCartForm.propTypes = propTypes

export default CustomerCheckoutCartForm